
import { useTranslation } from "react-i18next";
import BackBtn from "../../components/buttons/BackBtn";

export default function PortfolioBinanceBot() {
  const { t } = useTranslation();
  return (
    <div className="md:px-20 isolate px-6 lg:px-8 flex flex-1 items-center justify-center max-w-5xl">
      <div className="w-full flex flex-col justify-center items-start py-10 md:py-10">
        <div className="text-left mb-16 w-full">
        <BackBtn></BackBtn>
    
          <h1 className="mb-20 tx1 text-center">{t("portfolio.projects.binancebot.name")}</h1>
          <div className="mb-8 tm2">
            <b>{t("portfolio.projects.binancebot.intro")}</b><br />
          </div>
          <p className="tm2">
            {t("portfolio.projects.binancebot.goal")}
          </p>
          <div className="flex flex-col items-center justify-center mt-10 mx-auto gap-4">
            <a href="https://github.com/pawelmat142/binance-bot" className="card-image" target="_blank" rel="noopener noreferrer">
              <img src="/assets/projects/binance-bot.jpg" alt="binanceBot" />
            </a>
          </div>
        </div>
        <div className="w-full">
          <h2 className="tx2 text-left mb-4 md:mb-8">{t("portfolio.projects.binancebot.featuresTitle")}</h2>
          <h3 className="tx3 mb-4">{t("portfolio.projects.binancebot.mainFeaturesTitle")}</h3>
          <ul className="list-primary-dot ml-6 tm1">
            <li>{t("portfolio.projects.binancebot.mainFeature1")}</li>
            <li>{t("portfolio.projects.binancebot.mainFeature2")}</li>
            <li>{t("portfolio.projects.binancebot.mainFeature3")}</li>
          </ul>
          <h3 className="tx3 mb-4 mt-10">{t("portfolio.projects.binancebot.positionHandlingTitle")}</h3>
          <ul className="list-primary-dot ml-6 tm1 mb-8">
            <li>{t("portfolio.projects.binancebot.position1")}</li>
            <li>{t("portfolio.projects.binancebot.position2")}</li>
            <li>{t("portfolio.projects.binancebot.position3")}</li>
            <li>{t("portfolio.projects.binancebot.position4")}</li>
            <li>{t("portfolio.projects.binancebot.position5")}</li>
            <li>{t("portfolio.projects.binancebot.position6")}</li>
          </ul>
          <h3 className="tx3 mb-4 mt-10">{t("portfolio.projects.binancebot.authTitle")}</h3>
          <ul className="list-primary-dot ml-6 tm1 mb-8">
            <li>{t("portfolio.projects.binancebot.auth1")}</li>
            <li>{t("portfolio.projects.binancebot.auth2")}</li>
            <li>{t("portfolio.projects.binancebot.auth3")}</li>
          </ul>
          <h2 className="tx2 text-left mb-4 mt-20 md:mb-8">{t("portfolio.projects.binancebot.screenshotsTitle")}</h2>
          <div className="grid grid-cols-3 gap-1">
            <img src="/assets/projects/binance-bot-4.jpg" alt="binanceBot" />
            <img src="/assets/projects/binance-bot-3.jpg" alt="binanceBot" />
            <img src="/assets/projects/binance-bot-1.jpg" alt="binanceBot" />
          </div>
        </div>
        <div className="mt-16 tm2 opacity-80">
          <b className="highlight">{t("portfolio.projects.binancebot.noteTitle")}</b> {t("portfolio.projects.binancebot.note")}
        </div>
      </div>
    </div>
  );
}
